import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';
import { withI18n} from 'spa/Components/Context';
import InlineSelect from '@urbanmassage/component-library/lib/InlineSelect/InlineSelect';

const GiftsSelectCity = ({
  citiesApi,
  handleSelectCity,
  selectedCity,
  tracker,
}, {
  i18n,
}) => {
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCityIndex, setSelectedCityIndex] = useState(undefined);

  const loadCities = () => {
    citiesApi.load({ visible: 1 }).then((res) => {
      const list = res.cities.filter(cx => (
        cx.country_id === i18n.umRegion
      ), []).map(city => (
        {
          label: city.name,
          value: city.id,
        }
      ));
      setCityOptions(list);
    });
  };

  const onSelectCity = (val) => {
    handleSelectCity(val);
    tracker.track('Changed city on gifts page', {
      category: 'Gifts',
      label: val,
      city: val,
    });
  };

  const getInlineCitySelect = () => (
    <InlineSelect
      label={i18n._x('Select a city', 'Therapists list page')}
      id="city-select"
      onChange={val => onSelectCity(val)}
      options={cityOptions}
      selectedIndex={selectedCityIndex}
      showBorder
      size="small"
    />
  );

  useEffect(() => {
    if (cityOptions.length && selectedCity) {
      const index = cityOptions.findIndex(item => item.value === selectedCity);
      setSelectedCityIndex(index);
      return;
    }

    if (cityOptions.length) {
      handleSelectCity(cityOptions[0].value);
      setSelectedCityIndex(0);
    }
  }, [cityOptions, selectedCity]);

  useEffect(() => {
    if (cityOptions.length) {
      return;
    }
    loadCities();
  }, []);

  return (
    <div className="gifts__city-selection" data-testid="gifts-select-city-wrapper">
      <div className="gifts__city-selection-dropdown-wrapper">
        <div className="gifts__city-selection-text">
          {cityOptions.length && selectedCityIndex !== undefined ? (
            <Typography variant={TypeVariants.h4} fontFamily="heading">
              {i18n.__react('Buy a gift voucher in %(cityOptions)s', {
                cityOptions: getInlineCitySelect(),
              })}
            </Typography>
          ) : null}
        </div>
      </div>
    </div>
  );
};

GiftsSelectCity.propTypes = {
  citiesApi: PropTypes.shape({
    load: PropTypes.func.isRequired,
  }).isRequired,
  handleSelectCity: PropTypes.func.isRequired,
  selectedCity: PropTypes.string.isRequired,
  tracker: PropTypes.shape({
    track: PropTypes.func.isRequired,
  }).isRequired,

};

export default inject(({
  store: {
    citiesApi,
    tracker,
  },
}) => ({
  citiesApi,
  tracker,
}))(withI18n(GiftsSelectCity));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsSelectCity.jsx